import React, { useState } from 'react'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Col, Collapse, Row } from 'reactstrap'

const Faq = () => {

    const [open1,setOpen1] = useState(false)
    const [open2,setOpen2] = useState(false)
    const [open3,setOpen3] = useState(false)
    const [open4,setOpen4] = useState(false)
    const [open5,setOpen5] = useState(false)
    const [open6,setOpen6] = useState(false)

    const handleToggle1 = () => {
        setOpen1(!open1)
        console.log(open1)
    }

    const handleToggle2 = () => {
        setOpen2(!open2)
        console.log(open2)
    }

    const handleToggle3 = () => {
        setOpen3(!open3)
        console.log(open3)
    }

    const handleToggle4 = () => {
        setOpen4(!open4)
        console.log(open4)
    }

    const handleToggle5 = () => {
        setOpen5(!open5)
        console.log(open1)
    }

    const handleToggle6 = () => {
        setOpen6(!open6)
        console.log(open2)
    }


  return (
    <div id='website-responsive' style={{ backgroundColor:'#' }}>

{/* <div className='left-padding7rem1 right-padding7rem1 pt-5' style={{ marginTop:'', marginLeft:'' }}>
            <text className='fs-ss-30-1 text-ss-primary fw-800 text-raleway' style={{ letterSpacing:'0.9px'   }}>
                Frequently Asked Questions
            </text>
        </div> */}

        

                <section className='faq left-padding6rem1 right-padding6rem1'>

                    <div className='container-zk'>

                        <div className='row pt-md-0 pt-0 pb-4' id="faq-home">

                                <div className='col-md10 mxauto p-md5 pb-4' style={{borderRadius:"30px"}}>

                                    <div className='accordion accordion-flush px-md-4 px-2' id='accordionFlushExample'>

                                        <div className='accordion-item'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingOne'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseOne' aria-expanded='false' aria-controls='flush-collapseOne'>

                                                    <span className='fs-ss-16 text-poppins my-2 fw-700 text-zksecondary' style={{fontWeight:"600"}}>Panel List</span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseOne' className='accordion-collapse collapse' aria-labelledby='flush-headingOne' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'><ul className=''>
                            <li className=''>General Health Profile</li>
                            <li className=''>Hypertension Cardiac Profile</li>
                            <li className=''>Thyroid/Obesity</li>
                            <li className=''>Diabetes Panel</li>
                            <li className=''>Arthritis/Collagen Rheumatic Diseases</li>
                            <li className=''>Liver/Alcoholism</li>
                            <li className=''>Bone Density</li>
                            <li className=''>Kidney Cystitis</li>
                            <li className=''>Abdominal Pain/Pancreatitis</li>
                            <li className=''>Anemia Profile</li>
                            <li className=''>Ob/Prenatal</li>
                            <li className=''>Menstrual Disorder</li>
                            <li className=''>School Physical</li>
                       </ul> </span>

                                                </div>

                                            </div>

                                        </div>

                                        {/* <hr /> */}

                                        

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingThree'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseThree' aria-expanded='false' aria-controls='flush-collapseThree'>

                                                    <span className='fs-ss-16 text-poppins my-2  text-zk-secondary' style={{fontWeight:"600"}}>
System Panels </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseThree' className='accordion-collapse collapse' aria-labelledby='flush-headingThree' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                    <ul className=''>
                            <li className=''>Anemia (1R, 1L)</li>
                            <li className=''>Arthritis Profile (1R, 1L)</li>
                            <li className=''>Basic Metabolic Panel (BMP) (1R, 1L)</li>
                            <li className=''>Electrolytes Panel</li>
                            <li className=''>Hepatitis Panel</li>
                            <li className=''>Comprehensive Metaboli Panel (CMP) (1R)</li>
                            <li className=''>Liver Function Profile (1R)</li>
                            <li className=''>T3U, T4, TSH (1R)</li>
                            <li className=''>Renal Panel (RIP, Albumin, Phosphorus) (1R)</li>
                            <li className=''>Lipid Profile</li>
                            <li className=''>Prenatal Profile</li>
                            <li className=''>Drug Screen Or As Per Request (50mi, Urine)</li></ul>
                                                    </span>

                                                </div>

                                            </div>

                                        </div>

 

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingFour'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFour' aria-expanded='false' aria-controls='flush-collapseFour'>

                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>
Culture & Sensitivity</span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFour' className='accordion-collapse collapse' aria-labelledby='flush-headingFour' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'> <ul className=''>
                                <li className=''>Eye Culture</li>
                                <li className=''>Vaginal/Wet Mount</li>
                                <li className=''>Stool Culture</li>
                                <li className=''>Ear Culture</li>
                                <li className=''>Throat Culture</li>
                                <li className=''>GCCHL by DNA</li>
                                <li className=''>Herpes Culture</li>
                                <li className=''>Gram Stain</li>
                                <li className=''>Ova & Parasites</li>
                                <li className=''>Occult Blood Stool</li>
                                <li className=''>Urine Culture</li>
                                <li className=''>Nasal Culture</li>
                                <li className=''>Genital Culture</li>
                                <li className=''>Wound Culture</li>
                                <li className=''>Sputum Culture</li>
                            </ul>  </span>

                                                </div>

                                            </div>

                                        </div>

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingFive'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFive' aria-expanded='false' aria-controls='flush-collapseFive'>

                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>
Individual Tests</span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFive' className='accordion-collapse collapse' aria-labelledby='flush-headingFive' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                    <Row className=''>
                            <Col md='4' className=''>
                                <ul className=''>
                                    <li className=''>ABO & RH</li>
                                    <li className=''>AFP (Alpha-fetoprotein)</li>
                                    <li className=''>Alkaline Phosphatase</li>
                                    <li className=''>Amylase</li>
                                    <li className=''>ANA</li>
                                    <li className=''>Bilirubin Total</li>
                                    <li className=''>BUN</li>
                                    <li className=''>Calcium</li>
                                    <li className=''>CEA</li>
                                    <li className=''>Cholesterol</li>
                                    <li className=''>Cortisol Level</li>
                                    <li className=''>CPK</li>
                                    <li className=''>Creatinine</li>
                                    <li className=''>Depakane/Valproic Acid</li>
                                    <li className=''>DHEA-S</li>
                                    <li className=''>Electrophoresis Serum</li>
                                    <li className=''>Ferritin</li>
                                    <li className=''>Folic Acid</li>
                                    <li className=''>FSH</li>
                                    <li className=''>FTA-ABs</li>
                                    <li className=''>Glucose, Fasting</li>
                                    <li className=''>Glucose 2-Hr. PP</li>
                                    <li className=''>Hb A1C</li>
                                    <li className=''>HCG Beta Subunit Qual</li>
                                    <li className=''>HDL Cholesterol</li>
                                    {/* <li className=''></li>
                                    <li className=''></li>
                                    <li className=''></li>
                                    <li className=''></li>
                                    <li className=''></li> */}
                                </ul>
                            </Col>
                            <Col md='4' className=''>
                                <ul className=''>
                                    <li className=''>Hemoglobin Electrophoresis
</li>
                                    <li className=''>Hepatitis A Virus AB
</li>
                                    <li className=''>Hepatitis B Surl AB
</li>
                                    <li className=''>Hepatitis B Surl Antigen
</li>
                                    <li className=''>Hepatitis C AB
</li>
                                    <li className=''>Hepatitis Diag. Profile
</li>
                                    <li className=''>High Sensitive CRP
</li>
                                    <li className=''>HIV Antibody
</li>
                                    <li className=''>H. Pylori
</li>
                                    <li className=''>Iron</li>
                                    <li className=''>Iron Binding Capacity
</li>
                                    <li className=''>IGE</li>
                                    <li className=''>LDH</li>
                                    <li className=''>Lead Blood
</li>
                                    <li className=''>LE Screen
</li>
                                    <li className=''>Lithium
</li>
                                    <li className=''>Luteinizing Hormone
</li>
                                    <li className=''>Magnesium</li>
                                    <li className=''>Microalbumin
</li>
                                    <li className=''>Mono Test
</li>
                                    <li className=''>Phenobarbital
</li>
                                    <li className=''>Potassium</li>
                                    <li className=''>Potassium Ur.
</li>
                                    <li className=''>Pregnancy (Blood)
</li>
                                    <li className=''>Pregnancy (Urine)
</li>
                                    <li className=''>Progesterone
</li>
                                    <li className=''>Prolactin</li>
                                    <li className=''>Protein, Total
</li>
                                </ul>
                            </Col>
                            <Col md='4' className=''>
                                <ul className=''>
                                    <li className=''>Prothrombin Time with INR (PT/INR)
</li>
                                    <li className=''>PTT (Partial Thromboplastin Time)
</li>
                                    <li className=''>PSA</li>
                                    <li className=''>RA (Rheumatoid)
</li>
                                    <li className=''>Reticulocyte Count
</li>
                                    <li className=''>RPR
</li>
                                    <li className=''>Rubella Antibody
</li>
                                    <li className=''>Rubeola ABS IGG
</li>
                                    <li className=''>Sedimentation Rate
</li>
                                    <li className=''>SGOT</li>
                                    <li className=''>SGPT</li>
                                    <li className=''>Sickle Cell Screen
</li>
                                    <li className=''>Sodium</li>
                                    <li className=''>T3 RIA
</li>
                                    <li className=''>T3 Uptake
</li>
                                    <li className=''>T4 RIA
</li>
                                    <li className=''>Tegretol/Carbamazepine
</li>
                                    <li className=''>Testosterone
</li>
                                    <li className=''>Theophylline</li>
                                    <li className=''>Triglyceride
</li>
                                    <li className=''>TSH</li>
                                    <li className=''>Uric Acid
</li>
                                    <li className=''>Vancomycin (Peak)
</li>
                                    <li className=''>Vancomycin (Trough)
 </li>
                                    <li className=''>Vitamin B-12
</li>
                                    <li className=''>Vitamin D
</li>
                                </ul>
                            </Col>
                        </Row>
                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingSix'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFSix' aria-expanded='false' aria-controls='flush-collapseFSix'>

                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>Histology & Cytology </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFSix' className='accordion-collapse collapse' aria-labelledby='flush-headingSix' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                    <ul className='fs-ss- text-montserrat'>
                                                        <li className=''>BIOPSY</li>
                                                        <li className=''>PAP SMEAR</li>
                                                    </ul>
                                                     </span>

                                                </div>

                                            </div>

                                        </div>

 

                                        {/* <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingSeven'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFSeven' aria-expanded='false' aria-controls='flush-collapseFSeven'>

                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>How do you do an RSV test?   </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFSeven' className='accordion-collapse collapse' aria-labelledby='flush-headingSeven' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Tests to diagnose RSV are done on a sample of fluid from your nose. There are different ways to collect the sample:<br/>

1) Nasal aspirate or wash.
<br/>
2) Nasal swab test. </span>

                                                </div>

                                            </div>

                                        </div> */}

                                        {/* <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingEight'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseEight' aria-expanded='false' aria-controls='flush-collapseEight'>

                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}> What is toxicology testing, and how does United Lab Care help with toxicology testing? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseEight' className='accordion-collapse collapse' aria-labelledby='flush-headingEight' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Toxicology testing detects drugs in biological samples (urine, blood) to identify recent drug use, aiding compliance checks and safety measures. ULC offers comprehensive toxicology testing services using state-of-the-art equipment and expert analysis for precise results. </span>

                                                </div>

                                            </div>

                                        </div> */}

                                        {/* <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingNone' >

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseNine' aria-expanded='false' aria-controls='flush-collapseNine'>

                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>Can blood tests detect multiple STIs/STDs at once? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseNine' className='accordion-collapse collapse' aria-labelledby='flush-headingNone' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Some blood tests can screen for multiple infections simultaneously, providing comprehensive insights. </span>

                                                </div>

                                            </div>

                                        </div> */}

                                        {/* <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingTen'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseTen' aria-expanded='false' aria-controls='flush-collapseTen'>

                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>When will I get the results of the tests? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseTen' className='accordion-collapse collapse' aria-labelledby='flush-headingTen' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Turnaround time for these tests are between 24-48 hours but your doctor could receive your results in under 24 hours. We can deliver results for blood work in the same day. </span>

                                                </div>

                                            </div>

                                        </div> */}

                                        

                                    </div>

                                </div>

                        </div>

                    </div>

                </section>
    </div>
  )
}

export default Faq